exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-green{color:#fff;background-color:rgba(43,189,21,.667)}.btn-green:hover{color:#fff;background-color:#28be10}.btn-orange{color:#fff;background-color:rgba(224,78,10,.667)}.btn-orange:hover{color:#fff;background-color:#df4d0a}.btn-purple{color:#fff;background-color:rgba(127,10,223,.667)}.btn-purple:hover{color:#fff;background-color:#7f0adf}.btn-pink{color:#fff;background-color:rgba(223,10,92,.667)}.btn-pink:hover{color:#fff;background-color:#df0a5c}.btn-yellow{color:#fff;background-color:rgba(182,156,12,.667)}.btn-yellow:hover{color:#fff;background-color:#b69c0c}.btn-white,.btn-white:hover{color:#000;background-color:#fff}", ""]);

// exports
